import { render, staticRenderFns } from "./SubmissionEditorCard.vue?vue&type=template&id=9efcd772&scoped=true"
import script from "./SubmissionEditorCard.vue?vue&type=script&lang=js"
export * from "./SubmissionEditorCard.vue?vue&type=script&lang=js"
import style0 from "./SubmissionEditorCard.vue?vue&type=style&index=0&id=9efcd772&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9efcd772",
  null
  
)

export default component.exports